//
// * Utility functions that handle cookies, refactored from:
// * https://plainjs.com/javascript/utilities/set cookie get cookie and delete cookie
//

/**
 * Sets/Updates a given key with a value in a cookie
 * @param key {string}   Name of the key to set
 * @param value {string}   Value of the key in the cookie to set
 * @param days {number}   Number of days that the key should stay
 */

export const setCookie = ({
  key,
  value,
  days = 1
}: {
  key: string;
  value: string;
  days?: number;
}) => {
  const date = new Date();
  // 86400000 = number of seconds in a day
  date.setTime(date.getTime() + 86400000 * days);
  document.cookie = `${key}=${value};path=/;expires=${date.toUTCString()}`;
};
